import ReactGA from "react-ga4";
import clientConstants from "shared/constants/clientConstants";

const isDev = clientConstants.IS_DEV;

export const GAInitialize = () => {
  if (isDev) {
    console.log("[GA] Initialize | trackingId:", window.SERVER_DATA.featureFlags.googleId);
  }
  if (window.SERVER_DATA.featureFlags.isGoogleAnalyticsEnabled == "true") {
    ReactGA.initialize([
      {
        trackingId: window.SERVER_DATA.featureFlags.googleId,
      }
    ]);
    ReactGA.ga("set", "anonymizeIp", true);
  }
};

export const GATrackRoute = (path, title) => {
  if (isDev) {
    console.log("[GA] Pageview | path:", path, "| title:", title);
  }
  if (window.SERVER_DATA.featureFlags.isGoogleAnalyticsEnabled == "true") {
    ReactGA.send({
      hitType: "pageview",
      page: path,
      title: title
    });
  }
};

export const GAEvent = (category, action, label, value = 0) => {
  if (isDev) {
    console.log("[GA] Event | category:", category, "| action:", action, "| label:", label, "| value:", value);
  }
  if (window.SERVER_DATA.featureFlags.isGoogleAnalyticsEnabled == "true") {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: action,
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};
